import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FooterMain from './FooterMain';
import { locationActions, userActions } from '../../actions';

const FooterMainContainer = React.memo(({ dispatch, pickupLocations, footer, message, ...props }) => {
  const [deliveryAreas, setDeliveryAreas] = useState([]);

  useEffect(() => {
    dispatch(locationActions.getPickupLocations());
  }, []);

  useEffect(() => {
    locationActions
      .getDeliveryAreasByCurrentLocation()
      .then((data) => setDeliveryAreas(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const handleSubscribe = (formData) => {
    dispatch(userActions.subscribeEmailFooter(formData));
  };

  return (
    <FooterMain
      pickupLocations={pickupLocations}
      deliveryAreas={deliveryAreas}
      footer={footer}
      message={message}
      onSubscribe={handleSubscribe}
      {...props}
    />
  );
});

const mapStateToProps = ({ pickupLocations, storeInfo, alert }) => ({
  pickupLocations: pickupLocations.pickupLocations || [],
  footer: storeInfo.storeInfo && storeInfo.storeInfo.footer,
  message: alert.message,
});

export default connect(mapStateToProps)(FooterMainContainer);
